<template>
	<div :id="id" class="position-relative filter-container mainFilter" :class="typeFilter.value">
		<div v-if="typeFilter.value === 'list'" class="selectAll">
			<button class="selectAll_btn" type="button" @click="onSelectAll">
				<svg-sprite width="18" height="18" icon-id="ok"></svg-sprite>
				<span>Select all</span>
			</button>
		</div>
		<div v-if="typeFilter.value === 'date' && typeFilter.options === 'empty'" class="filter_head">
			<v-checkbox
					class="checkboxEmpty"
					@change="onChangeEmpty"
					:label="`Empty`"
					dense
					hide-details
					v-model="statusEmpty"
			></v-checkbox>
		</div>
		<div class="filter_body"
		     :class="typeFilter.value"
		>
			<v-date-picker
					v-if="typeFilter.value === 'date'"
					class="picker-table dataPickerFilter"
					:class="{'same': dates.length === 2 && dates[0] === dates[1]}"
					width="300"
					color="green"
					:disabled="isDisabled"
					v-model="dates"
					@change="onChange"
					prev-icon="mdi-menu-left"
					next-icon="mdi-menu-right"
					:allowed-dates="onAllowedDates"
					:events="functionEvents"
					isNoTitle
					range
					no-title
			></v-date-picker>
			<v-text-field
					v-else-if="typeFilter.value === 'note'"
					v-model="note"
					:type="typeFilter.type ? typeFilter.type : 'text'"
					:hide-spin-buttons="!typeFilter.isButtons"
					@input="onFilterNote"
					:label="labelFilter"
					class="noteFilter"
			></v-text-field>
			<div
					v-else-if="typeFilter.value === 'number'"
					class="numberWR"
			>
				<type-number
						:condition="conditionRefresh"
						:filterName="modelFilter"
						@updateNumber="onChangeNumber"
				></type-number>
			</div>
			<div v-else-if="typeFilter.value === 'address'">
				<v-autocomplete
						v-for="(item, index) in typeFilter.filters"
						v-model="selectAddress[item.filter]"
						:key="index"
						class="green-icon"
						:items="filtersList[item.filter]"
						:label="item.label"
						item-text="value"
						item-value="id"
						color="green"

						:menu-props="{contentClass: 'filter-dd', maxWidth: 300, minWidth: 300, nudgeWidth: 300, contentClass: 'fieldDropDown'}"
						@input="onAddressFilter({ value: $event, filter: item.filter })"
						multiple
						clearable
						small-chips
						deletable-chips
						chips
				></v-autocomplete>
				<v-select
						v-model="selectItemsTypes"
						:items="addressItemsTypes"
						item-text="name"
						item-value="value"
						label="Select type"
						@change="onAddressTypeFilter"
				></v-select>
			</div>
			<div v-else-if="typeFilter.value === 'options'">
				<div class="options">
					<div class="options_head">
						<div class="options_head-text">
							<span>On</span>
							<span>All</span>
							<span>Off</span>
						</div>
					</div>
					<div class="options_body">
						<radio-group
								title="Annual inspection"
								:radioKey="{ id: 'inspection', w: 25, h: 24 }"
								@updateRadio="onRadio($event, 'filter_option_inspection')"
								:isRefresh="isRefresh"
						></radio-group>
						<radio-group
								title="Alignment"
								:radioKey="{ id: 'alignment', w: 25, h: 24 }"
								@updateRadio="onRadio($event, 'filter_option_alignment')"
								:isRefresh="isRefresh"
						></radio-group>
						<radio-group
								title="PM service"
								:radioKey="{ id: 'pm', w: 25, h: 24 }"
								@updateRadio="onRadio($event, 'filter_option_pm')"
								:isRefresh="isRefresh"
						></radio-group>
						<radio-group
								title="Towing"
								:radioKey="{ id: 'towing', w: 20, h: 20 }"
								@updateRadio="onRadio($event, 'filter_option_towing')"
								:isRefresh="isRefresh"
						></radio-group>
					</div>
				</div>
			</div>
			<v-autocomplete
					v-else
					class="green-icon pt-5 mt-0"
					v-model="select"
					:items="getNumberToString"
					:label="labelFilter"
					item-text="value"
					item-value="id"
					color="green"
					:search-input.sync="search"
					:menu-props="{contentClass: 'filter-dd', maxWidth: 300, minWidth: 290, nudgeWidth: 300, contentClass: 'fieldDropDown'}"
					@input="changeFilter($event)"
					multiple
					clearable
					small-chips
					deletable-chips
					chips
			>
				<template slot="selection" slot-scope="{item}">
					<v-chip
							close
							small
							class="chip--select-multi autocompleteChip"
							@click:close="onDeleteChip(item)"
					>
						<span class="chipText">{{ item.value }}</span>
					</v-chip>
				</template>
				<template v-slot:item="{ active, item, attrs, on }">
					<v-list-item v-on="on" v-bind="attrs" #default="{ active }">
						<v-list-item-action>
							<v-checkbox :ripple="false" dense :input-value="active"></v-checkbox>
						</v-list-item-action>
						<v-list-item-content>
							<v-list-item-title>
								<v-row no-gutters align="center">
									<span v-if="item.color" class="colorItem" :style="`background: ${item.color}`"></span>
									<span>{{ item.value }}</span>
								</v-row>
							</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</template>
			</v-autocomplete>
		</div>
	</div>
</template>
<script>
// vuex
import { mapActions } from "vuex";
// components
import TypeNumber from "@/shared/table/filter-table/TypeNumber/TypeNumber";
import RadioGroup
from "@/components/Maintenance/Customer/CustomerForm/SixthTab/FilterTable/RadioGroup/RadioGroup";
// helpers
import debounce from "lodash.debounce";
import moment from "moment";
import getDefaultDate from "@/helper/getDefaultDate";
import { FILTER_KEYS, PAGE } from "@/constants/constants";

export default {
	name: "FilterTable",
	components: {
		TypeNumber,
		RadioGroup
	},
	props: {
		flag: String,
		isRefresh: String,
		isDisabled: Boolean,
		filtersList: Object,
		dateAllowed: Object,
		eventsList: Object,
		item: Object,
		defaultFilter: {
			type: Object,
			default: () => {
			}
		},
		dataFilter: {
			type: Array,
			default: () => []
		},
		modelFilter: {
			type: String,
			default: ''
		},
		filterUpdate: {
			type: Boolean
		},
		labelFilter: {
			type: String
		},
		typeFilter: {
			type: Object,
			default: null
		},
		refreshDate: String,
		externalValue: {
			type: [ Array, Object, String, Number, Boolean, null ],
			default: null
		},

	},
	computed: {
		getNumberToString() {
			if (this.typeFilter.groups) return this.items;
			return this.items.map(item => {
				return { id: item.id, value: item.value + '' };
			});
		},
		items() {
			return this.dataFilter.filter((value) => value != null && value);
		},
		id() {
			return "dd" + Math.round((Math.random() * (1000 - 20)) + 10);
		},
		update() {
			return this.filterUpdate;
		},
	},
	watch: {
		externalValue: {
			immediate: true,
			deep: true,
			handler(val) {
				// list (v-autocomplete multiple)
				if (this.typeFilter && this.typeFilter.value === 'list') {
					this.select = Array.isArray(val) ? val.slice() : [];
					return;
				}

				// date
				if (this.typeFilter && this.typeFilter.value === 'date') {
					if (val && (val.from || val.to)) {
						const from = val.from || null;
						const to = val.to || val.from || null;
						this.dates = [ from, to ].filter(Boolean);
					} else {
						this.dates = [];
					}
					return;
				}

				// note
				if (this.typeFilter && this.typeFilter.value === 'note') {
					this.note = typeof val === 'string' ? val : '';
					return;
				}

				// number (мінімально)
				if (this.typeFilter && this.typeFilter.value === 'number') {
					// якщо у тебе number зберігається як об'єкт {type, value}
					// тут можна дописати синк під твої поля (я не бачу весь number template)
					
				}
			}
		},
		filterUpdate(val) {
			if (val) {
				this.conditionRefresh = val;
				this.select = [];
				this.selectAddress = {};
				this.note = '';
				this.$emit('create-refresh', this.modelFilter);
			}
		},
		refreshDate(val, oldVal) {
			if (val !== oldVal) {
				this.select = [];
				this.dates = [];
				this.conditionRefresh = val;
				this.note = '';
			}
		},
		isRefresh(val, oldVal) {
			if (val !== oldVal) {
				// if (this.flag === PAGE.WORK_ORDERS && this.modelFilter === FILTER_KEYS.FILTER_STATUS) {
				// 	this.select = this.defaultFilter[FILTER_KEYS.FILTER_STATUS].filter(item => (item.id !== 9) && (item.id !== 11)).map(body => (body.id));
				// } else if (this.flag === PAGE.LOGBOOKS && this.modelFilter === 'filter_status_serves') {
				// 	this.select = [ 1 ];
				// } else {
				// 	this.select = [];
				// 	this.selectAddress = {};
				// }

				if (this.flag === PAGE.WORK_ORDERS && this.modelFilter === FILTER_KEYS.FILTER_STATUS) {
					this.select = this.defaultFilter[FILTER_KEYS.FILTER_STATUS]
						.filter(item => item.id !== 9 && item.id !== 11)
						.map(body => body.id);
				} else if (this.defaultFilter &&
						Object.prototype.hasOwnProperty.call(this.defaultFilter, this.modelFilter) &&
						Array.isArray(this.defaultFilter[this.modelFilter]) &&
						this.defaultFilter[this.modelFilter].length > 0
				) {
					this.select = this.defaultFilter[this.modelFilter];
				} else {
					this.select = [];
					this.selectAddress = {};
				}

				this.selectItemsTypes = null;
				this.statusReviewed = false;
				this.dates = [ ];
			}
		},
	},
	data() {
		return {
			note: '',
			conditionRefresh: null,
			selectAddress: {},
			select: [],
			dates: [],
			statusReviewed: false,
			statusEmpty: false,
			selectItemsTypes: null,
			search: '',
			addressItemsTypes: [
				{ name: 'PickUp', value: 1 },
				{ name: 'Delivery', value: 2 },
			],
		};
	},
	methods: {
		...mapActions([ 'safetyCalendar' ]),
		onDeleteChip({ id }) {
			const index = this.select.findIndex((itemId) => itemId === id);
			if (index !== null) {
				this.select.splice(index, 1);
				this.changeFilter(this.select);
			}
		},
		onAllowedDates(value) {
			if (!this.dateAllowed) return true;
			if (this.dateAllowed.onlyMonday) return new Date(value).getDay() === 1;
			if (this.dateAllowed.isSameOrBefore) return moment(value).isSameOrBefore(getDefaultDate());
		},
		functionEvents(date) {
			if (!this.eventsList) return false;
			const { orange, white } = this.eventsList;
			const isWhite = white.includes(date);
			const isOrange = orange.includes(date);

			if (isWhite && isOrange) return [ 'white', 'orange' ];
			if (isOrange) return [ 'orange' ];
			if (isWhite) return [ 'white' ];
		},
		onRadio(value, key) {
			const model = this.typeFilter.value;
			this.$emit("change-sort", { key, value, model });
		},
		onChangeNumber(values) {
			const model = this.typeFilter.value;
			const key = this.modelFilter;
			const value = { type: values.type, value: values.value };

			this.$emit("change-sort", { key, value, model });
		},
		onAddressFilter(args) {
			const { value, filter } = args;
			const model = this.typeFilter.value;
			const key = filter;

			// this.$set(this.addressSearch, filter, '');

			this.$emit("change-sort", { key, value, model });
		},
		onAddressTypeFilter(args) {
			const value = args;
			const model = 'addressType';
			const key = 'filter_rout_type';

			this.$emit("change-sort", { key, value, model });
		},
		changeFilter(value) {
			const model = this.typeFilter.value;
			const key = this.modelFilter;

			this.search = '';

			this.$emit("change-sort", { key, value, model });
		},
		onChange() {
			const model = this.typeFilter.value;
			const key = this.modelFilter;
			const [ from, to = from ] = this.dates;
			const value = { from, to };

			this.$emit("change-sort", { key, value, model });
		},
		onFilterNote: debounce(function() {
			const model = this.typeFilter.value;
			const key = this.modelFilter;
			const value = this.note.toLowerCase();

			this.$emit("change-sort", { key, value, model });
		}, 500),
		onSelectAll() {
			if ((this.modelFilter === this.item.value) || (this.modelFilter === this.item.valueFilter)) {
				this.$emit("updatePerLoad");
				const formattedItems = this.items.filter(item => item.value).map(body => body.id);
				setTimeout(() => this.select = formattedItems, 0);
				this.$emit("change-sort", { key: this.modelFilter, value: formattedItems });
			}
			this.$emit('updateFilterListAll');
		},
		onChangeEmpty() {
			const model = 'checkbox';
			const key = `${ this.modelFilter }_empty`;
			this.$emit("change-sort", { key, value: this.statusEmpty, model });
		},

		initSelectFilter() {
			if (this.flag === PAGE.WORK_ORDERS && this.modelFilter === FILTER_KEYS.FILTER_STATUS) {
				this.select = this.defaultFilter[FILTER_KEYS.FILTER_STATUS]
					.filter(item => item.id !== 9 && item.id !== 11)
					.map(body => body.id);
			} else if (this.defaultFilter &&
					Object.prototype.hasOwnProperty.call(this.defaultFilter, this.modelFilter) &&
					Array.isArray(this.defaultFilter[this.modelFilter]) &&
					this.defaultFilter[this.modelFilter].length > 0
			) {
				this.select = this.defaultFilter[this.modelFilter];
			}
		}

	},
	mounted() {
		this.$emit('filter-created', this.modelFilter);

		// якщо батько нічого не передав — тоді дефолт
		if (this.externalValue === null || typeof this.externalValue === 'undefined') {
			this.initSelectFilter();
		}

		this.initSelectFilter();
	},
};
</script>
<style lang="scss" scoped>
@import "FilterTable";
</style>

<style lang="scss">
@import 'FilterTableAll';
</style>
